module.exports = "\n.card-block {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n  \n.cardnumber {\n  padding-left:30px;\n  padding-right:35px;\n}\n  \n.cardname {\n  padding-left:30px;\n  padding-right:35px;\n}\n  \n.card_year_cvc{\n  padding-left:20px;\n  padding-right:20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/update-card/update-card.component.css
// module id = ./src/app/main/update-card/update-card.component.css
// module chunks = main